import { useState } from "react";

// ЛОГОТИП В ШАПКЕ.
//
// Знак рисуется в SVG прямо здесь — сайту не нужен файл, чтобы выглядеть
// законченным. Если положить в public/logo.png настоящий логотип компании,
// он подменит нарисованный автоматически, без правок кода.
//
// ЧТО НАРИСОВАНО: цветок сакуры, в сердцевине которого шанырак —
// перекрестье уыков в круге. Два национальных символа в одном знаке:
// японский цветок и казахский купол. Цвета берутся из палитры kj,
// поэтому знак меняется вместе с темой сайта.
const BrandMark = ({ className = "" }) => (
  <svg
    viewBox="0 0 48 48"
    className={className}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    {/* Пять лепестков сакуры с характерной выемкой на конце */}
    <g className="fill-kj-gold">
      {[0, 72, 144, 216, 288].map((angle) => (
        <path
          key={angle}
          d="M0 -6 C-5.6 -9.5 -7 -17.8 -2.6 -21.6 L0 -19.2 L2.6 -21.6 C7 -17.8 5.6 -9.5 0 -6 Z"
          transform={`translate(24 24) rotate(${angle})`}
        />
      ))}
    </g>

    {/* Шанырак: обод, внутреннее кольцо и перекрестье уыков */}
    <g
      transform="translate(24 24)"
      className="stroke-kj-ink"
      strokeWidth="1.4"
      strokeLinecap="round"
    >
      <circle r="7.4" fill="none" />
      <circle r="3.4" fill="none" strokeWidth="1.1" />
      {[0, 45, 90, 135].map((angle) => (
        <line
          key={angle}
          x1="-7.4"
          y1="0"
          x2="7.4"
          y2="0"
          transform={`rotate(${angle})`}
          strokeWidth="1.1"
        />
      ))}
    </g>
  </svg>
);

/**
 * Логотип: знак + название.
 *
 * Название пишется целиком — KAZAKH JAPAN TOURISM, — все три слова одним
 * кеглем, весом и разрядкой. Раньше «Tourism» стояло отдельной строкой в
 * два раза мельче и читалось как приписка, а не как часть имени компании.
 * На узких экранах строка переносится, но размер слов не меняется.
 *
 *  size="default" — шапка страницы
 *  size="compact" — плавающая шапка при скролле
 */
export default function Logo({ className = "", size = "default" }) {
  const [imageFailed, setImageFailed] = useState(false);

  const compact = size === "compact";
  const markSize = compact ? "h-9 w-9 sm:h-10 sm:w-10" : "h-11 w-11 sm:h-14 sm:w-14";
  const textSize = compact
    ? "text-xs sm:text-sm"
    : "text-xs sm:text-sm md:text-base";

  return (
    <a
      href="/"
      aria-label="Kazakh Japan Tourism"
      className={`group flex items-center gap-2.5 sm:gap-3.5 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kj-gold focus-visible:ring-offset-2 focus-visible:ring-offset-kj-dark ${className}`}
    >
      {imageFailed ? (
        <BrandMark
          className={`${markSize} flex-none transition-transform duration-500 group-hover:rotate-[18deg]`}
        />
      ) : (
        <img
          src="/logo.png"
          alt=""
          aria-hidden="true"
          onError={() => setImageFailed(true)}
          className={`${markSize} object-contain flex-none`}
        />
      )}

      <span
        className={`${textSize} font-extrabold uppercase tracking-[0.2em] leading-[1.35] text-kj-ink transition-colors group-hover:text-kj-gold`}
      >
        {/* Неразрывные пары: строка ломается только между «Japan» и
            «Tourism», а «Kazakh Japan» всегда остаётся вместе */}
        <span className="whitespace-nowrap">Kazakh&nbsp;Japan</span>{" "}
        <span className="whitespace-nowrap">Tourism</span>
      </span>
    </a>
  );
}
